let selectMain = document.querySelector('.select'),
    selectHeader = document.querySelectorAll('.select__header'),
    selectItem = document.querySelectorAll('.select__item'),
    current = document.querySelector('.select__current');

function select(select, container, head, item, curr) {
    head.forEach(item => {
        item.addEventListener('click', function H() {
            this.closest(select).classList.toggle('is-active');
        });
    })

    item.forEach(item => {
        item.addEventListener('click', function H() {
            let text = this.innerHTML;

            curr.innerHTML = text;
            container.classList.remove('is-active');
        });
    })

    window.addEventListener('click', (e) => {
        if(container) {
            if(!e.target.closest(select)) {
                container.classList.remove('is-active');
            }
        }
    });
}

select('.select', selectMain, selectHeader, selectItem, current);
